/* unplugin-vue-components disabled */import { render } from "./w-icon-button.vue?vue&type=template&id=c3a7666a&ts=true"
import script from "./w-icon-button.vue?vue&type=script&lang=ts"
export * from "./w-icon-button.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__